import React, { RefObject } from 'react'
import jwt from 'jwt-decode'
import { FileUpload } from 'primereact/fileupload'
import { InputText } from 'primereact/inputtext'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'

import '../Assets/Css/DataTable.css'

interface IProps {
    HandleFileUpload: any,
    Regla: Array<object>,
    Loading: boolean,
    HandleSelectRow: any,
    Paginado : {
        NumeroPagina : number,
        RegistrosPagina : number,
        NumeroPaginas : number,
        fil_CodigoPlan: string,
        fil_IDPlan: string,
        fil_Categoria: string,
        fil_Marca: string,
        fil_TipoPlan: string,
        fil_EANBonificado: string,
        fil_EstadoRegla: number}
}

interface IState {
    RefFile: RefObject<FileUpload>,
    ExpandedRows: Array<object>,
    GlobalFilter: string
}

export default class ReglasDataTable extends React.Component<IProps, IState> {

    constructor(props : any){
        super(props)
        this.state = {
            RefFile: React.createRef<FileUpload>(),
            ExpandedRows: [],
            GlobalFilter: ''
        }
    }

    Header(){
        var Token : string | null = localStorage.getItem('TOKEN-UN1FL3X')
        if(Token){
            var Decoded : any = jwt(Token)
            var Origen =  "Reglas"
            return(
                <div className="table-header">
                    <div className="table-header-left">
                        <span className="table-search">
                            <i className="pi pi-search" />
                            <InputText
                                value={this.state.GlobalFilter}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => this.setState({GlobalFilter: e.target.value})}
                                placeholder="Buscar en todas las columnas..."
                                className="table-search-input"
                            />
                        </span>
                    </div>
                    <div className="table-header-right">
                        {Decoded.IsDocumento === 'True' &&
                            <FileUpload
                                ref={this.state.RefFile}
                                mode="basic"
                                name="file"
                                auto
                                uploadHandler={(Event) => this.props.HandleFileUpload(Event, this.state.RefFile, Origen)}
                                customUpload
                                accept=".xlsm,application/msexcel,.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                chooseLabel="Subir documento"
                                className="table-upload-btn"
                            />
                        }

                    </div>
                </div>
            )
        }
    }

    RowExpansionTemplate = (Data : any) =>{
        return (
            <div className="orders-subtable">
                <DataTable value={Data.items}>
                    <Column field="EAN" header="EAN"/>
                    <Column field="Producto" header="Producto"/>
                    <Column field="Cantidad" header="Cantidad"/>
                    <Column field="UnidadMedida" header="UnidadMedida"/>
                </DataTable>
            </div>
        );
    }

    BodyIncluido = (RowData : any) => {
        return RowData.Incluido;
    }

    BodyExcluido = (RowData : any) => {
        return RowData.Excluido;
    }

    BodyBodega = (RowData : any) => {
        if(RowData.Bodegas) return <span className="badge badge-yes">Si</span>;
        else return <span className="badge badge-no">No</span>;
    }

    BodyMercados = (RowData : any) => {
        if(RowData.Mercados) return <span className="badge badge-yes">Si</span>;
        else return <span className="badge badge-no">No</span>;
    }

    BodyMayoristas = (RowData : any) => {
        if(RowData.Mayoristas) return <span className="badge badge-yes">Si</span>;
        else return <span className="badge badge-no">No</span>;
    }

    BodyEstado = (RowData : any) => {
        return (
            <React.Fragment>
                {
                    RowData.EstadoRegla ?
                    RowData.EstadoRegla.Codigo === '-1' ?
                        <span className="status status-warning">No Sincronizado</span>
                        :
                        (
                            RowData.EstadoRegla.Codigo === '0' ?
                                <span className="status status-success">{RowData.EstadoRegla.Mensaje}</span>
                                :
                                <span className="status status-error">Ocurrió un error</span>
                        )
                        :
                        <span className="status status-error">Ocurrió un error</span>
                }
            </React.Fragment>
        )
    }

    render(){
        return(
            <div className="table-wrapper">
                <DataTable
                    value={this.props.Regla}
                    selectionMode="single"
                    header={this.Header()}
                    expandedRows={this.state.ExpandedRows}
                    onRowToggle={(Event : any) => this.setState({ExpandedRows : Event.data})}
                    rowExpansionTemplate={this.RowExpansionTemplate}
                    className="p-datatable-customers"
                    loading={this.props.Loading}
                    onSelectionChange={Event => this.props.HandleSelectRow(Event.value)}
                    emptyMessage="No se encuentra ninguna regla registrada."
                    globalFilter={this.state.GlobalFilter}
                    scrollable
                    scrollHeight="calc(100vh - 270px)">
                        <Column expander style={{ width: '3em' }} />
                        <Column field="CodigoPlan" header="Código Plan" style={{ minWidth: '100px' }}/>
                        <Column field="IDPlan" header="ID Plan" style={{ minWidth: '90px' }}/>
                        <Column field="Categoria" header="Categoría" style={{ minWidth: '100px' }}/>
                        <Column field="Marca" header="Marca" style={{ minWidth: '100px' }}/>
                        <Column header="B." body={this.BodyBodega} style={{ width: '50px', textAlign:'center' }}/>
                        <Column header="Me." body={this.BodyMercados} style={{ width: '50px', textAlign:'center' }}/>
                        <Column header="Ma." body={this.BodyMayoristas} style={{ width: '50px', textAlign:'center' }}/>
                        <Column field="TipoPlan" header="Tipo Plan" style={{ minWidth: '100px' }}/>
                        <Column field="EANBonificado" header="EAN Bonificado" style={{ minWidth: '120px' }}/>
                        <Column field="EstadoRegla.Codigo" header="Estado" body={this.BodyEstado} style={{ minWidth: '130px' }}/>
                        <Column field="Incluido" header="Vendedores Incluidos" body={this.BodyIncluido} style={{ minWidth: '140px' }}/>
                        <Column field="Excluido" header="Vendedores Excluidos" body={this.BodyExcluido} style={{ minWidth: '140px' }}/>
                </DataTable>
            </div>
        )
    }
}
